<template>
    <v-sheet style="background-color:#fff;height:100%;">
        <v-app-bar
            app
            fixed
            dense
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; background-color:#fff; padding:0px; "
            elevation="0"
        >
            <v-btn @click="$router.back()" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>NOVA OBRA</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn text color="primary" @click="salvar">
                        <v-icon>save</v-icon>&nbsp; Salvar
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn text color="primary" @click="salvar">
                        <v-icon>save</v-icon>&nbsp; Salvar
                    </v-btn>
                </template>
            </v-toolbar-items>
        </v-app-bar>

        <v-container fill-height fluid>
            <v-layout justify-center wrap>
                <v-flex xs12 md12 fill-height>
                    <v-form>
                        <v-layout wrap>
                            <v-flex xs12 md12>
                                <v-container grid-list-xl>
                                    <v-card
                                        elevation="0"
                                        
                                        class="px-2 py-0"
                                    >
                                        <v-card-title
                                            style="color:#222;  "
                                        >INFORMAÇÕES</v-card-title>
                                        <v-layout wrap pt-5>
                                            <v-flex xs12 md12>
                                                <v-text-field
                                                    outlined
                                                    class="purple-input"
                                                    label="Título da Obra"
                                                    messages="Título da Obra que será utilizada para vincular aos fonogramas e aumentar a rentabilidade dos compositores."
                                                    v-model="work.name"
                                                    append-icon="help_outline"
                                                    @click:append="help('work_title')"
                                                />
                                            </v-flex>

                                            <!--v-flex xs12 md4>
                                                <v-text-field
                                                    class="purple-input"
                                                    label="ISWC"
                                                    messages="(opcional) Código de registro mundial da obra gerado pela sociedade a qual você é vinculado."
                                                    v-model="work.iswc"
                                                    append-icon="help_outline"
                                                    @click:append="help('work_iswc')"
                                                >

                                                </v-text-field>
                                            </v-flex-->

                                            <v-flex xs12>
                                                <v-switch
                                                    v-model="work.version"
                                                    label="Essa obra é uma versão?"
                                                    append-icon="help_outline"
                                                    @click:append="help('work_version')"
                                                ></v-switch>
                                            </v-flex>

                                            <v-flex xs12 md12 v-if="work.version">
                                                <v-text-field
                                                    outlined
                                                    class="purple-input"
                                                    label="Título da Obra Original"
                                                    messages="Título da Obra que será utilizado para vincular os fonogramas e aumentar a rentabilidade dos compositores."
                                                    v-model="work.version_name"
                                                    append-icon="help_outline"
                                                    @click:append="help('work_original_title')"
                                                />
                                            </v-flex>

                                            <v-flex xs12 md12 v-if="work.custom_name">
                                                <v-text-field
                                                    outlined
                                                    class="purple-input"
                                                    label="Nome"
                                                    messages="Nome customizado. Enviado através da API."
                                                    v-model="work.custom_name"
                                                    disabled
                                                />
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-textarea
                                                    outlined
                                                    auto-grow
                                                    label="Letra"
                                                    v-model="work.lyric"
                                                    append-icon="help_outline"
                                                    @click:append="help('work_lyrics')"
                                                ></v-textarea>
                                            </v-flex>
                                           
                                        </v-layout>
                                    </v-card>
                                </v-container>
                            </v-flex>
                            <v-flex xs12 md12 pb-5>
                                <v-container>
                                    <v-card
                                        elevation="0"
                                        class="px-2"
                                        
                                    >
                                        <v-card-title
                                            style="color:#222;  "
                                        >COMPOSITORES</v-card-title>
                                        <v-layout wrap pt-5>
                                            <v-flex xs12 md12 xl12>
                                                <v-layout wrap>
                                                    <v-flex
                                                        xs12
                                                        md12
                                                        xl6
                                                        style="background-color:#fafafa"
                                                        py-3
                                                        px-3
                                                    >
                                                        <div>
                                                            Para distribuir nas plataformas é necessário que ela esteja 100% editada.
                                                            <br />
                                                            <br />Fazemos isso para reforçar o nosso compromisso com o compositor, garantindo que os direitos autorais sejam pagos corretamente através das editoras.
                                                            <br />
                                                            <br />Se a obra for de sua autoria recomendamos que você a edite em uma editora da sua preferência.<br>Você pode editar também com a Nova Música Gospel, mas é necessário fazer o pagamento do produto antes e depois entrar em contato através do e-mail 
                                                            <a
                                                                to="mail:autoral@novamusicagospel.com.br"
                                                            >autoral@novamusicagospel.com.br</a>.
                                                        </div>
                                                    </v-flex>

                                                    <v-flex xs12 md12 xl6>
                                                        <v-radio-group
                                                            v-model="work.type"
                                                            class="ml-5"
                                                        >
                                                            <v-radio
                                                                label="Minha composição / Tenho participação"
                                                                value="propria"
                                                            ></v-radio>
                                                            <v-radio
                                                                label="Direto com Autor"
                                                                value="direto_autor"
                                                            ></v-radio>
                                                            <v-radio
                                                                label="Essa obra está editada"
                                                                value="editada"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex
                                                xs12
                                                md12
                                                xl12
                                                v-if="work.type!=null"
                                                class="text-center my-3"
                                            >
                                                <v-divider class="py-0"></v-divider>
                                                <div class="py-5">
                                                    <v-btn
                                                        @click="dialog_editora=true"
                                                        text
                                                        v-show="work.type=='editada'"
                                                        color="red"
                                                        class="mx-2"
                                                        outlined
                                                    >
                                                        <v-icon>add</v-icon>Editora
                                                    </v-btn>

                                                    <v-btn
                                                        text
                                                        @click.stop="add_composer(null)"
                                                        color="red"
                                                        class="mx-2"
                                                        outlined
                                                    >
                                                        <v-icon>add</v-icon>Compositor
                                                    </v-btn>
                                                </div>
                                                <v-divider></v-divider>
                                            </v-flex>

                                            <v-flex xs12>
                                                <template
                                                    v-if="publishers.length>0 && work.type=='editada' "
                                                >
                                                    <v-flex xs12 md12>
                                                        <v-form>
                                                            <v-expansion-panels
                                                                :value="panel_editora"
                                                                multiple
                                                                color="grey"
                                                            >
                                                                <v-expansion-panel
                                                                    readonly
                                                                    class="px-3"
                                                                    v-for="(publisher, indice) in publishers"
                                                                    :key="publisher.row_count"
                                                                >
                                                                    <v-expansion-panel-header
                                                                        style="color:#000; background-color:#8BC34A"
                                                                        dark
                                                                    >
                                                                        <strong>
                                                                            Editora
                                                                            <template
                                                                                v-if="publisher.name"
                                                                            >- {{publisher.name}}</template>
                                                                        </strong>
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn
                                                                            elevation="0"
                                                                            style="max-width:270px!important"
                                                                            color="white"
                                                                            @click="add_composer(null, publisher)"
                                                                        >+ compositor desta editora</v-btn>
                                                                        <template v-slot:actions>
                                                                            <v-icon
                                                                                color="grey"
                                                                            >$vuetify.icons.expand</v-icon>
                                                                        </template>
                                                                    </v-expansion-panel-header>

                                                                    <v-divider></v-divider>
                                                                    <v-expansion-panel-content>
                                                                        <v-layout wrap class="my-3">
                                                                            <v-flex xs12 md7>
                                                                                <v-text-field
                                                                                    v-model="publisher.name"
                                                                                    disabled
                                                                                    class="purple-input"
                                                                                    label="Editora"
                                                                                />
                                                                            </v-flex>

                                                                            <v-flex xs12 md4>
                                                                                <v-text-field
                                                                                    v-model="publisher.pivot.share"
                                                                                    class="ml-4"
                                                                                    label="Participação"
                                                                                    messages="A % que a editora tem sobre essa obra"
                                                                                    suffix="%"
                                                                                    @change="force_rerender"
                                                                                    v-money="moneyk"
                                                                                    :key="publisher.id"
                                                                                    v-if="render_field"
                                                                                    append-icon="help_outline"
                                                                                    @click:append="help('work_percentile')"
                                                                                />
                                                                            </v-flex>

                                                                            <v-flex
                                                                                xs12
                                                                                md1
                                                                                class="text-right"
                                                                            >
                                                                                <v-btn
                                                                                    fab
                                                                                    dark
                                                                                    small
                                                                                    color="error"
                                                                                    @click="remove_editora(indice, publisher.id)"
                                                                                >
                                                                                    <v-icon>mdi-minus</v-icon>
                                                                                </v-btn>
                                                                            </v-flex>
                                                                            <div
                                                                                style="background-color:#ddd; width:100%,  "
                                                                                class="flex xs12 md12 my-3"
                                                                            >
                                                                                <listwithshare
                                                                                    :composers="composers"
                                                                                    :publisher_id="publisher.id"
                                                                                    @remove_composer="remove_composer"
                                                                                />
                                                                            </div>
                                                                        </v-layout>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </v-form>
                                                    </v-flex>
                                                </template>
                                            </v-flex>
                                            <v-flex mx12>
                                                <!--compositores -->
                                                <!-- ENTRA AQUI -->
                                                <!--@composers_changed="composers_changed" @remove_person="remove_person"-->
                                                <listwithshare
                                                    :composers="composers"
                                                    :updated="update_editora_time"
                                                    @remove_composer="remove_composer"
                                                />
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-flex>

                <!-- DIALOG PUBLISHER -->
                <v-dialog v-model="dialog_editora" persistent max-width="600px">
                    <v-card>
                        <v-card-title style="background-color:#4caf50" class="white--text">
                            <span class="headline">
                                <b>Buscar e Adicionar Editora</b>
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-flex xs12 sm12 md12>
                                    <v-combobox
                                        v-model="item_editora_selected"
                                        :items="items_editora"
                                        item-text="name"
                                        item-value="id"
                                        label="Editora"
                                        placeholder="Busque pela Editora"
                                        append-icon="mdi-database-search"
                                        return-object
                                    ></v-combobox>
                                </v-flex>
                            </v-container>
                            <small>
                                Busque pela Editora digitando o seu nome e clique em seu nome para selecionar.
                                <br />Para adicionar mais de um continue buscando e selecionando.
                                <br />Se você não encontrar a sua editora entre em contato no
                                <b>autoral@novamusicagospel.com.br</b>.
                            </small>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!--v-btn color="blue darken-1" flat @click="dialog_composer = false">Close</v-btn-->
                            <v-btn
                                dark
                                text
                                color="blue darken-1"
                                @click="dialog_editora = false"
                            >Fechar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <modalmessage ref="modal" />
            </v-layout>
        </v-container>

        <WorkHelp ref="work_help" />
    </v-sheet>
</template>

<script>
import listwithshare from "../../../components/composers/list_with_share";
import WorkService from "../../../app/Rest/work";
import modalmessage from "../../../components/shared/modalmessage";
import WorkHelp from "../../../components/help/work";
var workService = null;

export default {
    components: {
        listwithshare,
        modalmessage,
        WorkHelp
    },
    data: () => ({
        work: { type: null },
        obra_editada: null,
        //editora
        dialog_editora: false,
        publishers: [],
        item_editora_selected: null,
        panel_editora: [0, 1, 2, 3],
        items_editora: [],
        is_loading_editora: false,
        search_editora: null,
        composers: [],
        count_composers: 0,
        publishers_selected: null,
        update_editora_time: null,
        count_composers: 0,
        count_publishers: 0,
        moneyk: {
            decimal: ".",
            thousands: "",
            precision: 2,
            masked: true /* doesn't work with directive */
        },
        render_field: true
    }),
    created() {
        workService = WorkService.build();
        if (this.$route.params.id) {
            this.$store.commit("loading");
            workService.getOne(this.$route.params.id).then(e => {
                //////console.log(e)            ;
                this.work = e.items.work;
                this.composers = e.items.composers;
                this.publishers = e.items.publishers;

                this.$store.commit("loading", false);
                //console.log("------>>>")
                //console.log(this.composers);
            });
        }

        this.items_editora = this.$store.getters.publishers;
        console.log(this.items_editora);
    },
    watch: {
        composers() {
            this.count_composers++;
        },
        "work.type": {
            handler: function() {
                //so funciona quando é uma nova obra
                //
                if (this.work.id == null && this.work.type == "propria") {
                    //adiciona o compositor automaticamente
                    let user = this.$store.getters.user;
                    let composer = this.$store.getters.composer;
                    //console.log("composer", composer);
                    this.composers = [];
                    var p = {
                        name: composer.name,
                        id: composer.id,
                        row_count: this.count_composers,
                        cpf: user.myself.cpf,
                        pivot: { share: "100.00", publisher_id: null }
                    };
                    this.add_composer(p);
                }
            },
            deep: true
        },
        item_editora_selected: function() {
            if (this.item_editora_selected == null) return;
            //console.log("item_editora_selected");
            //console.log(this.item_editora_selected);
            this.add_editora(this.item_editora_selected);
            this.item_editora_selected = null;
        },
        search_editora(val) {
            /*if (val == null || val == "") return;
            val = val.toLowerCase();
            this.is_loading_editora = true;
            this.items_editora = this.$store.getters.publishers.filter(e => {
                if (e.name.toLowerCase().indexOf(val) >= 0) {
                    return true;
                    this.is_loading_editora = true;
                }
                return false;
            });*/
        },
        publishers() {
            this.panel_editora = [];
            this.publishers.forEach((val, index) => {
                this.panel_editora.push(index);
            });
        }
    },
    methods: {
        help(tag) {
            this.$refs.work_help.show(tag);
        },
        salvar() {
            //verificar participacao total
            let total_percentual = 0;
            this.composers.forEach(e => {
                total_percentual += e.pivot.share
                    ? e.pivot.share.replace(".", "") * 1
                    : 0;
            });
            this.publishers.forEach(e => {
                total_percentual += e.pivot.share
                    ? e.pivot.share.replace(".", "") * 1
                    : 0;
            });

            if (total_percentual > 10000) {
                this.$refs.modal.show(
                    "Atenção",
                    "A soma dos percentuais não pode ser maior que 100%",
                    "Entendi"
                );
                return;
            }

            if (total_percentual < 10000) {
                this.$refs.modal.show(
                    "Atenção",
                    "A soma dos percentuais não pode ser menor que 100%",
                    "Entendi"
                );
                return;
            }

            let twork = Object.assign({}, this.work);
            twork.composers = this.composers;
            twork.publishers = this.publishers;
            //console.log(twork);
            this.$store.dispatch("loading_full");
            workService
                .save_own_rights(twork)
                .then(e => {
                    if (e.status == "error") {
                        this.$refs.modal.show("Atenção", e.msg, "Entendi");
                        return;
                    }
                    //service
                    this.$store.dispatch("obras_update");

                    this.work = e.items.work;
                    this.composers = e.items.composers;
                    this.publishers = e.items.publishers;
                    this.$refs.modal.show(
                        "Tudo certo",
                        "Sua obra foi salva com sucesso.",
                        "ENTENDI"
                    );
                })
                .finally(() => {
                    this.$store.dispatch("loading_full", false);
                });
        },
        /**
         * Não gostaria de fazer isso, mas o bug do v-money
         * com o v-textfield na % de participação forçou a isso
         */
        force_rerender() {
            this.render_field = false;
            this.$nextTick(() => {
                this.render_field = true;
            });

            return;
        },
        /**
         * Remover o compositor
         */
        remove_composer(c_indice) {
            let _c = [];
            this.composers.map((e, i) => {
                if (i != c_indice) {
                    _c.push(e);
                }
            });
            this.composers = _c;
        },
        remove_editora: function(indice, publisher_id) {
            let _p = [];
            let _c = [];

            _p = this.publishers.filter((e, i) => {
                if (i != indice) {
                    return true;
                }
                return false;
            });

            _c = this.composers.filter((e, i) => {
                if (e.pivot) {
                    if (e.pivot.publisher_id == publisher_id) {
                        return false;
                    }
                }
                return true;
            });

            this.publishers = _p;
            this.composers = _c;
        },
        /**
         * Remover a editora
         */
        add_editora: function(editora) {
            //se já estiver, não precisamos adicionar novamente
            for (var a = 0; a < this.publishers.length; a++) {
                if (editora.id == this.publishers[a].id) {
                    //console.log("encontrou");
                    return;
                }
            }

            this.count_publishers = this.count_publishers + 1;

            if (editora != null) {
                //console.log("editora valida");
                //console.log(editora);
                editora.row_count = this.count_publishers;
                //se nao houver o pivot, criamos um temporario
                if (editora.pivot == null) {
                    editora.pivot = { share: "" };
                    editora._temp_share = "";
                }

                //console.log("editora pós pivot");
                //console.log(editora);
            } else {
                editora = {};
                editora = {
                    row_count: this.count_publishers,
                    pivot: { share: "" },
                    composers: [],
                    _temp_share: ""
                };
            }

            this.publishers.push(editora);
            //console.log(this.publishers);
        },

        //Adiciona uma pessoa ao conjunto atual
        add_composer: function(p_person = null, publisher = null) {
            //console.log("add_composer");
            //console.log(p_person);

            this.count_composers = this.count_composers + 1;
            //var composers_container = [];

            //composers_container = this.composers;

            if (p_person != null) {
                p_person.row_count = this.count_composers;
                //se nao houver o pivot, criamos um temporario
                if (p_person.pivot == null) {
                    p_person.pivot = { share: "" };
                }
            } else {
                p_person = {};
                p_person = {
                    row_count: this.count_composers,
                    cpf: this.cpf_consulta,
                    pivot: { publisher_id: null }
                };
            }
            ////console.log(composers_container);
            //nao adiciona quem ja foi adicionado
            //for (var a = 0; a < composers_container.length; a++) {
            //    if (p_person.id == composers_container[a].id) {
            //        return;
            //    }
            //}

            if (publisher !== null) {
                ////console.log(publisher)
                p_person.pivot.publisher_id = publisher.id;
                /*if(!publisher.composers){
                    publisher.composers = []
                }
                publisher.composers.push(p_person)  */
            } //else{
            this.composers.push(p_person);
            // }

            //console.log(this.composers);
            ////console.log("adicionando pessoa ao composer", this.publishers_selected, composers_container, this.publishers);
            //this.publishers.push({});
            //this.publishers.pop();
            this.update_editora_time = new Date();
            //console.log("/add_composer");
        }
    }
};
</script>
